(function () {
  var rootSelector = '[data-autoplay][class*="ai-video-reviews-"]';
  var wrapperSelector = '[class*="ai-video-wrapper-"]';
  var videoSelector = 'video[data-lazy-video]';

  function loadVideo(video) {
    if (!video || video.dataset.casidorVideoReady === 'true') return;

    if (video.dataset.videoPoster && !video.poster) {
      video.poster = video.dataset.videoPoster;
    }

    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'metadata';

    var wrapper = video.closest(wrapperSelector);
    var poster = wrapper && wrapper.querySelector('[data-video-poster-src]');
    if (poster) {
      poster.src = poster.dataset.videoPosterSrc;
      poster.removeAttribute('data-video-poster-src');
    }

    Array.prototype.slice.call(video.querySelectorAll('source[data-src]')).forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();
    video.dataset.casidorVideoReady = 'true';
  }

  function markReady(video) {
    var wrapper = video && video.closest(wrapperSelector);
    if (!wrapper) return;
    if (!video.paused && video.readyState >= 2) {
      wrapper.classList.add('is-video-ready');
      wrapper.classList.add('is-video-playing');
    }
  }

  function playVideo(video, userInitiated) {
    if (!video) return;
    loadVideo(video);

    if (userInitiated) {
      video.muted = false;
      video.removeAttribute('muted');
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(function () {
        markReady(video);
      }).catch(function () {});
    } else {
      markReady(video);
    }
  }

  function getVisibleVideo(root) {
    var carousel = root.querySelector('[data-carousel]');
    var videos = Array.prototype.slice.call(root.querySelectorAll(videoSelector));
    var carouselRect = carousel && carousel.getBoundingClientRect();

    if (!carouselRect) return videos[0];

    for (var i = 0; i < videos.length; i += 1) {
      var rect = videos[i].getBoundingClientRect();
      var horizontalOverlap = Math.min(rect.right, carouselRect.right) - Math.max(rect.left, carouselRect.left);
      var verticalOverlap = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      if (horizontalOverlap > Math.min(rect.width * 0.2, 48) && verticalOverlap > 24) {
        return videos[i];
      }
    }

    return videos[0];
  }

  function pauseOtherVideos(activeVideo, root) {
    Array.prototype.slice.call(root.querySelectorAll(videoSelector)).forEach(function (video) {
      if (video !== activeVideo) {
        video.pause();
        var wrapper = video.closest(wrapperSelector);
        if (wrapper) wrapper.classList.remove('is-video-playing');
      }
    });
  }

  function prepareRoot(root) {
    if (!root || root.dataset.casidorVideoFixReady === 'true') return;
    root.dataset.casidorVideoFixReady = 'true';

    Array.prototype.slice.call(root.querySelectorAll(videoSelector)).forEach(function (video) {
      ['loadeddata', 'canplay', 'playing', 'play'].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          markReady(video);
        });
      });
    });

    if (!('IntersectionObserver' in window)) {
      Array.prototype.slice.call(root.querySelectorAll(videoSelector)).forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.dataset.casidorInView = 'true';
          Array.prototype.slice.call(root.querySelectorAll(videoSelector)).forEach(loadVideo);
        } else {
          root.dataset.casidorInView = 'false';
          Array.prototype.slice.call(root.querySelectorAll(videoSelector)).forEach(function (video) {
            video.pause();
            var wrapper = video.closest(wrapperSelector);
            if (wrapper) wrapper.classList.remove('is-video-playing');
          });
        }
      });
    }, { rootMargin: '1100px 0px', threshold: 0.01 });

    observer.observe(root);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll(rootSelector)).forEach(prepareRoot);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-volume-toggle]')) return;

    var wrapper = event.target.closest && event.target.closest(wrapperSelector);
    if (!wrapper) return;

    var video = wrapper.querySelector(videoSelector);
    var root = wrapper.closest(rootSelector);
    if (!video || !root) return;
    if (root.tagName && root.tagName.toLowerCase().indexOf('video-reviews-carousel-') === 0) return;

    loadVideo(video);
    pauseOtherVideos(video, root);

    if (video.paused) {
      playVideo(video, true);
    } else {
      video.pause();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
